import { instance } from "services/axiosConfig";
import genAiInstance from "./genaiworker";
import axios from "axios";
import { updateModule } from "services/apis";
const getErrorCode = (err) => {
  return err.response?.status;
};

export const fetchProductCountry = (userQuery, cb) => {
  genAiInstance
    .get("/extract_brand_and_country", {
      params: {
        user_query: userQuery, // Send raw user input
      },
      headers: {
        Accept: "application/json",
      },
    })
    .then((response) => {
      cb(response.data);
    })
    .catch((err) => {
      console.error("GenAI API Error:", err);
      cb(undefined, err, getErrorCode(err));
    });
};

export const fetchModules = (params, cb, offset = 0, size = 8) => {
  const endpoint = `/api/modulems/v1/dam/e-details?pageoffset=${offset}&pagesize=${size}`;

  instance
    .post(endpoint, {
      product: params.product || "Unbranded",
      country: params.country || "Unbranded",
    })
    .then((response) => {
      cb(response.data);
    })
    .catch((err) => {
      console.error("API Error:", err?.response?.data || err.message || err);
      cb(undefined, err, err?.response?.status);
    });
};
//downloadEdt
export const downloadEDetail = (docId, cb) => {
  const endpoint = `/api/modulems/v1/dam/document/${docId}/download/file`;

  instance
    .get(endpoint, {
      responseType: "blob",
      headers: {
        Accept: "application/pdf, application/octet-stream",
      },
    })
    .then((response) => {
      // Get filename from headers or use default
      const contentDisposition = response.headers["content-disposition"];
      let filename = `EDetail_${docId}.pdf`;

      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/);
        if (filenameMatch && filenameMatch[1]) {
          filename = filenameMatch[1];
        }
      }

      // Create download link
      const blob = new Blob([response.data], {
        type: response.headers["content-type"] || "application/pdf",
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      link.style.display = "none";

      document.body.appendChild(link);
      link.click();

      // Clean up after download
      setTimeout(() => {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        cb && cb(true); // Success callback
      }, 100);
    })
    .catch((err) => {
      console.error("Download failed:", err);
      cb && cb(false, err, err?.response?.status);
    });
};

//preview EDT

export const fetchPreview = (assetId, cb) => {
  const endpoint = `/api/modulems/v1/ncciAssets/${assetId}`;
  instance
    .get(endpoint)
    .then((response) => {
      cb(response.data);
    })
    .catch((err) => {
      console.error("API Error:", err?.response?.data || err.message || err);
      cb(undefined, err, err?.response?.status);
    });
};

export const getAllModules = async (
  assetId,
  slideId,
  countryName,
  objective,
  topic,
) => {
  const params = new URLSearchParams();
  params.append("countryName", countryName);

  if (objective && objective.trim() !== "") {
    params.append("communicationObjective", objective);
  }

  if (topic && topic.trim() !== "") {
    params.append("topic", topic);
  }

  const endpoint = `/api/modulems/v1/ncciAssets/${assetId}/pages/${slideId}?${params.toString()}`;

  try {
    const response = await instance.get(endpoint);
    return response.data;
  } catch (err) {
    console.error("API Error:", err?.response?.data || err.message || err);
    return null;
  }
};

// Classify Slide Assets API
export const classifySlideAssets = async (
  asset_id,
  page_id,
  countryName,
  objective,
  topic,
) => {
  try {
    const response = await genAiInstance.post(
      `slide/classify-slide-assets`,
      {
        asset_id,
        page_id,
        countryName,
        communicationObjective: objective,
        topic,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
        timeout: 180000,
        //3mins
      },
    );
    return response.data;
  } catch (err) {
    console.error(
      "classifySlideAssets API Error:",
      err?.response?.data || err.message || err,
    );
    // Optionally, throw a more descriptive error
    throw new Error(
      err?.response?.data?.message ||
        err?.message ||
        "Failed to fetch slide asset classification.",
    );
  }
};

export const getSummaryInfo = (
  assetId,
  pageId,
  countryName,
  objective,
  topic,
  cb,
) => {
  genAiInstance
    .post("slide/generate-summary", {
      asset_id: assetId,
      page_id: pageId,
      countryName,
      communicationObjective: objective,
      topic,
    })
    .then((response) => {
      cb(response.data);
    })
    .catch((err) => {
      console.error("GenAI API Error:", err);
      cb(undefined, err, getErrorCode(err));
    });
};

//sliderecomm api

export const slideRecommendation = async (assetId, selectedPageIds) => {
  try {
    const response = await genAiInstance.post(
      `recommendations/slides`,
      {
        assetId: assetId,
        selectedPageIds: selectedPageIds,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
        timeout: 180000, // 3mins
      },
    );
    return response.data;
  } catch (err) {
    console.error(
      "slideRecommendation API Error:",
      err?.response?.data || err.message || err,
    );
    throw new Error(
      err?.response?.data?.message ||
        err?.message ||
        "Failed to fetch slide recommendations.",
    );
  }
};

export const createMultipleModules = async (
  assetId,
  pageIds,
  topic,
  communication_objective,
  signal = null, // Add optional abort signal parameter
) => {
  try {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
      timeout: 600000, // 10 mins
    };

    // Add abort signal to config if provided
    if (signal) {
      config.signal = signal;
    }

    const response = await genAiInstance.post(
      `module-creator/modules`,
      {
        assetId,
        pageIds,
        topic,
        communication_objective,
      },
      config,
    );
    return response.data;
  } catch (err) {
    // COMPREHENSIVE CANCELLATION CHECKING

    // 1. Check for axios cancellation (if using CancelToken - legacy)
    if (axios.isCancel(err)) {
      console.log("Request cancelled: axios.isCancel");
      throw new Error("Request was cancelled");
    }

    // 2. Check for AbortController/AbortSignal errors (modern)
    if (err.name === "AbortError" || err.name === "CanceledError") {
      console.log("Request cancelled: AbortError/CanceledError");
      throw new Error("Request was cancelled");
    }

    // 3. Check for axios cancellation error code
    if (err.code === "ERR_CANCELED" || err.code === "ECONNABORTED") {
      console.log("Request cancelled: ERR_CANCELED/ECONNABORTED");
      throw new Error("Request was cancelled");
    }

    // 4. Check error message for cancellation keywords
    if (
      err.message &&
      (err.message.toLowerCase().includes("cancel") ||
        err.message.toLowerCase().includes("abort") ||
        err.message === "Request was cancelled")
    ) {
      console.log("Request cancelled: message contains cancel/abort");
      throw new Error("Request was cancelled");
    }

    // 5. If none of the above, it's a REAL API error
    console.error(
      "createMultipleModules API Error:",
      err?.response?.data || err.message || err,
    );
    throw new Error(
      err?.response?.data?.message ||
        err?.message ||
        "Failed to create multiple modules.",
    );
  }
};

// Create a promise wrapper for updateModule
export const updateModulePromise = (payload, moduleId) => {
  return new Promise((resolve, reject) => {
    updateModule(payload, moduleId, (response, error) => {
      if (response) {
        resolve(response);
      } else {
        reject(error);
      }
    });
  });
};
